import { render, staticRenderFns } from "./PageNavbarFederationDropdown.vue?vue&type=template&id=3bcf1428&scoped=true"
import script from "./PageNavbarFederationDropdown.vue?vue&type=script&lang=ts"
export * from "./PageNavbarFederationDropdown.vue?vue&type=script&lang=ts"
import style0 from "./PageNavbarFederationDropdown.vue?vue&type=style&index=0&id=3bcf1428&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bcf1428",
  null
  
)

export default component.exports